
// import React from "react";

// const RegisterCTA = ({ onSubmit, formRef, toastMsg }) => (
//   <section id="register" className="py-5">
//     <div className="container">
//       <div className="row align-items-center g-4">
//         <div className="col-12 col-lg-6">
//           <h2 className="fw-bold">Register Your Community</h2>
//           <p className="text-muted">
//             Get onboarding support to set up events, notices, elections, security, and resident services.
//           </p>
//           <ul className="list-unstyled">
//             <li className="mb-2"><i className="bi bi-check2-circle text-success me-2"></i> Free demo & quick onboarding</li>
//             <li className="mb-2"><i className="bi bi-check2-circle text-success me-2"></i> Role-based admin access</li>
//             <li className="mb-2"><i className="bi bi-check2-circle text-success me-2"></i> Mobile apps for residents & staff</li>
//           </ul>
//         </div>

//         <div className="col-12 col-lg-6">
//           <div className="card shadow-sm">
//             <div className="card-body">
//               <h5 className="card-title">Community Registration</h5>
//               {toastMsg && <div className="alert alert-success" role="alert">{toastMsg}</div>}

//               <form ref={formRef} onSubmit={onSubmit}>
//                 <div className="row g-3">
//                   <div className="col-12">
//                     <label className="form-label" htmlFor="communityName">Community Name</label>
//                     <input className="form-control" id="communityName" name="communityName" required />
//                   </div>
//                   <div className="col-12 col-md-6">
//                     <label className="form-label" htmlFor="city">City</label>
//                     <input className="form-control" id="city" name="city" required />
//                   </div>
//                   <div className="col-12 col-md-6">
//                     <label className="form-label" htmlFor="totalFlats">Total Flats</label>
//                     <input type="number" min="1" className="form-control" id="totalFlats" name="totalFlats" required />
//                   </div>
//                   <div className="col-12 col-md-6">
//                     <label className="form-label" htmlFor="contactName">Contact Person</label>
//                     <input className="form-control" id="contactName" name="contactName" required />
//                   </div>
//                   <div className="col-12 col-md-6">
//                     <label className="form-label" htmlFor="email">Email</label>
//                     <input type="email" className="form-control" id="email" name="email" required />
//                   </div>
//                   <div className="col-12">
//                     <label className="form-label" htmlFor="phone">Phone</label>
//                     <input type="tel" className="form-control" id="phone" name="phone" required />
//                   </div>
//                   <div className="col-12">
//                     <button className="btn btn-primary w-100" type="submit">Request Onboarding</button>
//                     <small className="text-muted d-block mt-2">
//                       By submitting, you agree to our Terms & Privacy Policy.
//                     </small>
//                   </div>
//                 </div>
//               </form>

//             </div>
//           </div>

//           <div className="text-center mt-3">
//             <a href="#faq" className="link-primary text-decoration-none">
//               <i className="bi bi-question-circle me-1"></i> Read FAQs
//             </a>
//           </div>
//         </div>
//       </div>
//     </div>
//   </section>
// );

// export default RegisterCTA;


import React, { useEffect, useState } from "react";
import "./register.mobile.css";       // <- tiny CSS for the mobile flip UX
import "./flip-cards.mobile.css";
import "../../../styles/theme.css"

const RegisterCTA = ({ onSubmit, formRef, toastMsg }) => {
  // Track view: desktop/tablet (>= md) vs mobile (< md) so we render only ONE form at a time
  const [isMdUp, setIsMdUp] = useState(() =>
    typeof window !== "undefined"
      ? window.matchMedia("(min-width: 768px)").matches
      : true
  );

  useEffect(() => {
    const mq = window.matchMedia("(min-width: 768px)");
    const handler = (e) => setIsMdUp(e.matches);
    // Older Safari uses addListener
    if (mq.addEventListener) mq.addEventListener("change", handler);
    else mq.addListener(handler);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener("change", handler);
      else mq.removeListener(handler);
    };
  }, []);

  // Mobile flip
  const [flipped, setFlipped] = useState(false);
  const hintId = "register-hint";
  const liveId = "register-live";

  const toggleFlip = () => setFlipped((f) => !f);

  // --- Content blocks reused in both views ---
  const Benefits = () => (
    <>
      {/* <h2 className="fw-bold">Register Your Community</h2> */}
      <p className="text-muted">
        Get onboarding support to set up events, notices, elections, security, and resident services.
      </p>
      <ul className="list-unstyled mb-0">
        <li className="mb-2">
          <i className="bi bi-check2-circle text-success me-2" aria-hidden="true"></i>
          Free demo & quick onboarding
        </li>
        <li className="mb-2">
          <i className="bi bi-check2-circle text-success me-2" aria-hidden="true"></i>
          Role-based admin access
        </li>
        <li className="mb-2">
          <i className="bi bi-check2-circle text-success me-2" aria-hidden="true"></i>
          Mobile apps for residents & staff
        </li>
      </ul>
    </>
  );

  const FormCard = () => (
    <div className="card shadow-sm">
      <div className="card-body">
        <h5 className="card-title">Community Registration</h5>
        {toastMsg && (
          <div className="alert alert-success" role="alert" aria-live="polite">
            {toastMsg}
          </div>
        )}

        <form ref={formRef} onSubmit={onSubmit} aria-label="Community registration form">
          <div className="row g-3">
            <div className="col-12">
              <label className="form-label" htmlFor="communityName">Community Name</label>
              <input className="form-control" id="communityName" name="communityName" required />
            </div>
            <div className="col-12 col-md-6">
              <label className="form-label" htmlFor="city">City</label>
              <input className="form-control" id="city" name="city" required />
            </div>
            <div className="col-12 col-md-6">
              <label className="form-label" htmlFor="totalFlats">Total Flats</label>
              <input type="number" min="1" className="form-control" id="totalFlats" name="totalFlats" required />
            </div>
            <div className="col-12 col-md-6">
              <label className="form-label" htmlFor="contactName">Contact Person</label>
              <input className="form-control" id="contactName" name="contactName" required />
            </div>
            <div className="col-12 col-md-6">
              <label className="form-label" htmlFor="email">Email</label>
              <input type="email" className="form-control" id="email" name="email" required />
            </div>
            <div className="col-12">
              <label className="form-label" htmlFor="phone">Phone</label>
              <input
                type="tel"
                className="form-control"
                id="phone"
                name="phone"
                inputMode="tel"
                pattern="[0-9+\-\s()]*"
                required
              />
            </div>
            <div className="col-12">
              <button className="btn btn-primary w-100" type="submit">Request Onboarding</button>
              <small className="text-muted d-block mt-2">
                By submitting, you agree to our Terms & Privacy Policy.
              </small>
            </div>
          </div>
        </form>
      </div>
    </div>
  );

  // --- Desktop view (unchanged two-column layout) ---
  if (isMdUp) {
    return (
      <section id="register" className="py-5">
        <div className="container">
          <div className="row align-items-center g-4">
            <div className="col-12 col-lg-6">
              <Benefits />
            </div>

            <div className="col-12 col-lg-6">
              <FormCard />
              <div className="text-center mt-3">
               <a href="#faq"> Read FAQs</a>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  // --- Mobile view (< md): single flip card (front: benefits, back: form) ---
  return (
    <section id="register" className="py-5">
      <div className="container">
        {/* Visually-hidden guidance & live status for screen readers */}
        <span id={hintId} className="visually-hidden">
          Tap, click, or press Enter/Space to flip and reveal the registration form.
        </span>
        <span id={liveId} className="visually-hidden" aria-live="polite">
          {flipped ? "Form shown." : "Overview shown."}
        </span>

        <div
          className={`flip-card register-flip ${flipped ? "is-flipped" : ""}`}
          role="button"
          tabIndex={0}
          aria-expanded={flipped}
          aria-describedby={`${hintId} ${liveId}`}
          aria-roledescription="flip card"
          onClick={() => toggleFlip()}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              toggleFlip();
            }
          }}
        >
          <div className="flip-card-inner">
            {/* FRONT: overview + benefits + CTA */}
            <div className="flip-card-face flip-card-front" aria-hidden={flipped}>
              <div className="d-flex align-items-center mb-3">
                <div className="icon-wrap icon-animated text-primary-label" aria-hidden="true">
                  <i className="bi bi-clipboard-plus icon-lg"></i>
                </div>
                <h3 className="mb-0 ms-2">Register Your Community</h3>
              </div>
              <Benefits />
              <div className="mt-3">
                <button
                  type="button"
                  className="btn btn-outline-teal w-100"
                  onClick={(e) => {
                    e.stopPropagation(); // don't trigger container's flip twice
                    toggleFlip();
                  }}
                  aria-controls="register-form"
                >
                  Open Registration Form
                </button>
              </div>
            </div>

            {/* BACK: form (clicks inside should NOT flip) */}
            <div
              className="flip-card-face flip-card-back"
              aria-hidden={!flipped}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="mb-2 d-flex align-items-center">
                <div className="icon-wrap icon-animated text-primary-label" aria-hidden="true">
                  <i className="bi bi-journal-text icon-lg"></i>
                </div>
                <h3 className="mb-0 ms-2 .text-primary-label">Community Registration</h3>
              </div>

              {/* Form card (same fields, wired to formRef & onSubmit) */}
              <div id="register-form">
                {toastMsg && (
                  <div className="alert alert-success" role="alert" aria-live="polite">
                    {toastMsg}
                  </div>
                )}

                <form ref={formRef} onSubmit={onSubmit} aria-label="Community registration form">
                  <div className="row g-2">
                    <div className="col-12">
                      <label className="form-label small" htmlFor="communityName">Community Name</label>
                      <input className="form-control" id="communityName" name="communityName" required />
                    </div>
                    <div className="col-12">
                      <label className="form-label small" htmlFor="city">City</label>
                      <input className="form-control" id="city" name="city" required />
                    </div>
                    <div className="col-12">
                      <label className="form-label small" htmlFor="totalFlats">Total Flats</label>
                      <input type="number" min="1" className="form-control" id="totalFlats" name="totalFlats" required />
                    </div>
                    <div className="col-12">
                      <label className="form-label small" htmlFor="contactName">Contact Person</label>
                      <input className="form-control" id="contactName" name="contactName" required />
                    </div>
                    <div className="col-12">
                      <label className="form-label small" htmlFor="email">Email</label>
                      <input type="email" className="form-control" id="email" name="email" required />
                    </div>
                    <div className="col-12">
                      <label className="form-label small" htmlFor="phone">Phone</label>
                      <input
                        type="tel"
                        className="form-control"
                        id="phone"
                        name="phone"
                        inputMode="tel"
                        pattern="[0-9+\-\s()]*"
                        required
                      />
                    </div>
                    <div className="col-12">
                      <button className="btn btn-primary w-100" type="submit">
                        Request Onboarding
                      </button>
                      <small className="text-muted d-block mt-2">
                        By submitting, you agree to our Terms & Privacy Policy.
                      </small>
                    </div>
                  </div>
                </form>
              </div>

              <div className="mt-3">
                <button
                  type="button"
                  className="btn btn-outline-secondary w-100"
                  onClick={() => toggleFlip()}
                >
                  Back to Overview
                </button>
              </div>

              {/* <div className="text-center mt-3">
               <a href = "#faq"> Read FAQs</a>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RegisterCTA;
